import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';

import { TextEditComponent } from '@grid/components';
import { DataFilterService } from '@grid/services';
import { Constants } from '@grid/utils/constants';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, fromEvent, tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-filter-text-edit',
  templateUrl: './filter-text-edit.component.html',
  styleUrls: ['./filter-text-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterTextEditComponent
  extends TextEditComponent
  implements AfterViewInit, OnInit
{
  @ViewChild('input', { static: true }) input: ElementRef;

  constructor(
    private dataFilterService: DataFilterService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.dataFilterService.refreshFilters$
      .pipe(
        untilDestroyed(this),
        filter(
          (message) =>
            message?.toString().toUpperCase() ===
              Constants.DefaultValues.allValues ||
            message === this.context.data.id
        ),
        tap(() => {
          this.context.data[this.context.column.columnDef] = null;

          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }

  ngAfterViewInit(): void {
    fromEvent(this.input.nativeElement, 'input')
      .pipe(
        debounceTime(300),
        tap(() => {
          this.context.cell.actions.onEdited();
        })
      )
      .subscribe();
  }
}
